module.exports = __webpack_public_path__ + "img/wu-big.cfbeb642.svg";